import { render, staticRenderFns } from "./_SystemCard.vue?vue&type=template&id=0666a1e0&"
import script from "./_SystemCard.vue?vue&type=script&lang=ts&"
export * from "./_SystemCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports